var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("modal", {
    attrs: { "show-on-mount": "", size: "large" },
    on: { hidden: _vm.hide },
    scopedSlots: _vm._u([
      {
        key: "modal-title",
        fn: function() {
          return [
            _c("h3", [
              _vm._v(
                _vm._s(
                  _vm.resource(
                    "JourneyBuilder_Sankey_TouchpointOverviewPopup_Statistics"
                  )
                ) +
                  " " +
                  _vm._s(_vm.brick.name)
              )
            ])
          ]
        },
        proxy: true
      },
      {
        key: "modal-body",
        fn: function() {
          return [
            _c("div", { staticClass: "form-group" }, [
              _c("div", { staticClass: "row" }, [
                _c(
                  "div",
                  { staticClass: "col-12" },
                  [
                    _c(
                      "a",
                      {
                        staticClass: "btn btn-outline-secondary mr-3",
                        class: { disabled: !_vm.navigateToDashboardUrl },
                        attrs: { href: _vm.navigateToDashboardUrl || "#" }
                      },
                      [
                        _vm._v(
                          "\n                        " +
                            _vm._s(
                              _vm.resource(
                                "JourneyBuilder_Sankey_TouchpointInfo_OpenDashboard_Button"
                              )
                            ) +
                            "\n                    "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c("navigate-to-actionable-report-link", {
                      staticClass: "btn btn-outline-secondary",
                      attrs: {
                        "journey-id": _vm.journey.id,
                        "highlighted-brick-id": _vm.brick.id
                      }
                    })
                  ],
                  1
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-6" }, [
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-4" }, [
                      _c("label", { staticClass: "control-label" }, [
                        _vm._v(
                          _vm._s(
                            _vm.resource("JourneyBuilder_Sankey_Period_Label")
                          )
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-8" },
                      [_c("period-picker", { attrs: { disabled: "" } })],
                      1
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-6" }, [
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-4" }, [
                      _c("label", { staticClass: "control-label" }, [
                        _vm._v(
                          "\n                                " +
                            _vm._s(
                              _vm.resource(
                                "JourneyBuilder_Sankey_InflowPeriod_Label"
                              )
                            ) +
                            "\n                            "
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-8" },
                      [_c("inflow-period-picker", { attrs: { disabled: "" } })],
                      1
                    )
                  ])
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-12" }, [
                  _c("h3", [
                    _vm._v(
                      _vm._s(
                        _vm.resource(
                          "JourneyBuilder_Sankey_TouchpointOverviewPopup_Reporting"
                        )
                      )
                    )
                  ])
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group" }, [
              _c("div", { staticClass: "row" }, [
                _c(
                  "div",
                  { staticClass: "col-12" },
                  [
                    _c("sankey-v2", {
                      attrs: {
                        data: _vm.selectedBrickSankeyData,
                        types: _vm.sankeyTypes,
                        "is-loading": _vm.isLoading,
                        displayGoalRoutes: false,
                        selectedBrickId: _vm.brick.id
                      }
                    })
                  ],
                  1
                )
              ])
            ])
          ]
        },
        proxy: true
      },
      {
        key: "modal-footer",
        fn: function() {
          return [
            _c("div", { staticClass: "row justify-content-end" }, [
              _c("div", { staticClass: "col-auto" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-secondary btn-lg",
                    on: {
                      click: function($event) {
                        return _vm.hide()
                      }
                    }
                  },
                  [
                    _c("i", { staticClass: "fas fa-check-circle" }),
                    _vm._v(
                      "  " +
                        _vm._s(_vm.resource("Button_OK")) +
                        "\n                "
                    )
                  ]
                )
              ])
            ])
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }